import { Observable, throwError } from 'rxjs';
import { ILoggingService } from '@kikkz/shared/logging/util';

/**
 * Aborts a request whose id would land in the URL path.
 *
 * The backend hands out entities without an id (see the mapper's warnings), and callers
 * pass what they have. Interpolating `''` would silently request a DIFFERENT endpoint
 * (`PUT .../fixture/` instead of `.../fixture/{id}`, `GET .../season/` instead of
 * `.../season/{userId}`) and answer with a 404/405 that says nothing about the real
 * cause. Failing here instead keeps the store's normal error path — error state plus
 * snackbar — with a message that names the missing id.
 *
 * Shared by every prediction-game HTTP service (the tenant ones included) so the rule
 * and its wording exist exactly once.
 */
export function missingIdRequest<T>(
  source: string,
  method: string,
  what: string,
  logger: ILoggingService,
): Observable<T> {
  const message = `[${source}] ${method}: missing ${what} — the backend delivered an entity without an id; not sending an incomplete URL`;
  logger.error(message);
  return throwError(() => new Error(message));
}
